import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';

import { storage } from '@/service/firebase.js';

import PhotoUploader from '@/components/photo-upload/PhotoUploader.vue';

type Photo = {
  name: string;
  bucket: string;
  path: string;
  isSelected: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderPhotos',
  props: {
    workOrderId: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  workOrderId: string;
  title?: string;
}

const pendingOptimisticAdds = ref<string[]>([]);
const jobFiles = ref<Photo[]>([]);
const selectedPhotoIndex = ref<number>(0);
const previewImagesActive = ref<boolean>(false);
const confirmDeletePhotosActive = ref<boolean>(false);



const jobPhotos = computed(() => {
  return jobFiles.value.filter(p => !isPdf(p));
});

const jobPdfFiles = computed(() => {
  return jobFiles.value.filter(p => isPdf(p));
});

function isPdf(photo: Photo): boolean {
  return photo.path.split('?')[0].endsWith('.pdf');
}

const selectedPhotos = computed<Photo[]>(() => {
  return jobFiles.value.filter(p => p.isSelected);
});
const isMobile = computed<boolean>(() => {
  return window.innerWidth < 768;
});

onMounted(async () => {
  await getJobSitePhotos();
});

async function getJobSitePhotos() {
  const storageRef = storage.ref(props.workOrderId);
  const result = await storageRef.listAll();
  const getPhotos = async item => {
    const url = await item.getDownloadURL();
    return {
      name: item.name,
      bucket: item.bucket,
      path: url,
      isSelected: false,
    };
  };
  Promise.all(result.items.map(getPhotos)).then(photos => {
    pendingOptimisticAdds.value = [];
    jobFiles.value = photos || [];
  });
}

function onOptimisticAdd(files: File[]): void {
  if (files.length) {
    Array.from(files).forEach(file => {
      const src = URL.createObjectURL(file);
      pendingOptimisticAdds.value = [...pendingOptimisticAdds.value, src];
    });
  }
}
async function onUploadSuccess(ref): Promise<void> {
  pendingOptimisticAdds.value.shift();
  const url = await ref.getDownloadURL();
  jobFiles.value = jobFiles.value.concat({
    name: ref.name,
    bucket: ref.bucket,
    path: url,
    isSelected: false,
  });
}

function onPreviewPhoto(photo: Photo): void {
  selectedPhotoIndex.value = jobPhotos.value.findIndex(jp => jp.name === photo.name);
  previewImagesActive.value = true;
}

function onPreviewNextPhoto() {
  if (selectedPhotoIndex.value === null) return;

  if (selectedPhotoIndex.value + 1 === jobPhotos.value.length) {
    selectedPhotoIndex.value = 0;
  } else {
    selectedPhotoIndex.value += 1;
  }
}

function onPreviewPreviousPhoto() {
  if (selectedPhotoIndex.value === null) return;
  if (selectedPhotoIndex.value - 1 < 0) {
    selectedPhotoIndex.value = jobPhotos.value.length - 1;
  } else {
    selectedPhotoIndex.value -= 1;
  }
}

function onSelectPhoto(photo: Photo) {
  jobFiles.value = jobFiles.value.map(p => {
    if (p.name === photo.name) {
      p.isSelected = !photo.isSelected;
    }
    return p;
  });
}

function confirmDeletePhotos() {
  confirmDeletePhotosActive.value = true;
}

async function onDeleteFile(file: Photo) {
  try {
    const imageRef = storage.refFromURL(file.path);
    await imageRef.delete();
    jobFiles.value = jobFiles.value.filter(p => p.path !== file.path);
  } catch (e) {
    console.error(e);
  }
}

async function onDeletePhotos() {
  confirmDeletePhotosActive.value = false;
  try {
    const toDelete: string[] = [];
    for await (const photo of selectedPhotos.value) {
      const imageRef = storage.refFromURL(photo.path);
      await imageRef.delete();
      toDelete.push(photo.path);
    }

    jobFiles.value = jobFiles.value.filter(p => !toDelete.includes(p.path));
  } catch (e) {
    console.error(e);
  }
}

return { __sfc: true,pendingOptimisticAdds, jobFiles, selectedPhotoIndex, previewImagesActive, confirmDeletePhotosActive, props, jobPhotos, jobPdfFiles, isPdf, selectedPhotos, isMobile, getJobSitePhotos, onOptimisticAdd, onUploadSuccess, onPreviewPhoto, onPreviewNextPhoto, onPreviewPreviousPhoto, onSelectPhoto, confirmDeletePhotos, onDeleteFile, onDeletePhotos, PhotoUploader }
}

})